<template>
	<component :is="currentStellungnahmeDetailView" ref="childComponent" />
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useStore, authUser } from '../store';
import StellungnahmeDetail from '@/views/StellungnahmeDetail.vue';
import StellungnahmeDetailWerberat from './StellungnahmeDetailWerberat.vue';

export default defineComponent({
	name: 'Wrapper',
	components: {},
	setup() {
		const store = useStore();
		const user = computed(() => store.state.user);

		const currentStellungnahmeDetailView = computed(() => {
			const authUserRoles = authUser.value.roles.map((role) => role.name);
			if (
				authUserRoles.includes('Vorstand') ||
				authUserRoles.includes('Werberat') ||
				authUserRoles.includes('Junger Werberat') ||
				authUserRoles.includes('Kleiner Senat A') ||
				authUserRoles.includes('Kleiner Senat B')
			) {
				return StellungnahmeDetailWerberat;
			}
			return StellungnahmeDetail;
		});

		return {
			currentStellungnahmeDetailView,
		};
	},
	beforeRouteLeave(to, from, next) {
		const childComponent = this.$refs.childComponent;

		if (childComponent && typeof childComponent.handleBeforeRouteLeave === 'function') {
			childComponent.handleBeforeRouteLeave(to, from, next);
		} else {
			next();
		}
	},
});
</script>
